const API_PORT = 3002;

/**
 * URL base da API (local, servidor de testes, produção).
 * REACT_APP_API_URL sobrescreve quando definida no build.
 * Local: localhost:3002. IPs conhecidos: hostname:3002.
 * Quando a app está na porta 3000 (dev): mesmo host na porta 3002 (permite Monitoramento em outras estações).
 * Demais: mesma origem (proxy / same-origin, não quebra login).
 */
export function getApiBaseUrl() {
  if (typeof process !== 'undefined' && process.env?.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/$/, '');
  }
  if (typeof window === 'undefined') return '';
  const { hostname, port, protocol } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return `http://localhost:${API_PORT}`;
  if (hostname === '177.102.48.21' || hostname === '45.168.203.209') return `${protocol}//${hostname}:${API_PORT}`;
  if (port === '3000') return `${protocol}//${hostname}:${API_PORT}`;
  return window.location.origin;
}
